import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTruck, FaUser, FaLock, FaSpinner } from 'react-icons/fa';
import { login, isAuthenticated } from '../../services/adminAuth';
import './AdminLogin.css';

function AdminLogin() {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated()) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await login(credentials.username, credentials.password);
      navigate('/admin/dashboard');
    } catch (err) {
      console.error('Login error:', err);
      // Handle different error formats
      const errorMessage = err?.error || err?.message || 'Server error. Please check if the backend server is running.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-header">
          <FaTruck className="admin-login-icon" />
          <h1>V&R Courier Ltd</h1>
          <p>Admin Dashboard</p>
        </div>

        <form className="admin-login-form" onSubmit={handleSubmit}>
          {error && <div className="admin-error-message">{error}</div>}

          <div className="admin-form-group">
            <label>
              <FaUser className="input-icon" />
              Username
            </label>
            <input
              type="text"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              placeholder="Enter username"
              required
              disabled={loading}
            />
          </div>

          <div className="admin-form-group">
            <label>
              <FaLock className="input-icon" />
              Password
            </label>
            <input
              type="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              placeholder="Enter password"
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className="admin-login-btn" disabled={loading}>
            {loading ? (
              <>
                <FaSpinner className="spinner" /> Logging in...
              </>
            ) : (
              'Login to Dashboard'
            )}
          </button>
        </form>

        <div className="admin-login-footer">
          <p>Secure Admin Access Only</p>
          <p className="admin-help-text">
            Default: username: <code>admin</code> / password: <code>admin123</code>
          </p>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;

